import { token } from '@atlaskit/tokens';
import { type StylesConfig } from '@databases/atlaskit/Select';

export const baseSelectStyleConfig: StylesConfig<any> = {
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '260px',
    position: 'relative',
    boxShadow: 'none',
    margin: '0',
  }),
  menuList: (base) => ({
    ...base,
    padding: '0',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0',
  }),
  control: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    paddingLeft: token('space.150', '.75rem'),
    paddingRight: token('space.150', '.75rem'),
  }),
  placeholder: (base) => ({
    ...base,
    left: token('space.300', '1.5rem'),
    paddingLeft: token('space.100', '.75rem'),
  }),
  input: (base) => ({
    ...base,
    overflow: 'hidden',
    marginLeft: token('space.050', '0.5rem'),
  }),
};

export const isRenderedInSidePanelStyling: StylesConfig<any> = {
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '260px',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0',
  }),
  control: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    border: 'none',
  }),
  placeholder: (base) => ({
    ...base,
    left: token('space.300', '1.5rem'),
  }),
  input: (base) => ({
    ...base,
    marginLeft: token('space.100', '0.5rem'),
    '> div > input': {
      width: '100% !important',
    },
  }),
};

export const customPlaceholderAndControlSpacingStyling: StylesConfig<any> = {
  placeholder: (base) => ({
    ...base,
    left: 'auto',
    marginLeft: token('space.150', '.75rem'),
  }),
  control: (base) => ({
    ...base,
    paddingLeft: 0,
    paddingRight: 0,
  }),
};
